import loadable from "@loadable/component";
import { useParams } from "react-router-dom";
import InvoiceSkeleton from "../../components/Reusable/InvoiceSkeleton";
import SwitchTab from "../../components/Reusable/SwitchTab";
import APIS from "../../constant/Endpoint";
import useGetHook from "../../customHooks/useGetHook";

const InvoicePreviewComponent = loadable(
  () => import("../../components/BranchInvoice/CargoInvoicePreview")
);

const CargoBranchInvoicePreview = () => {
  const { id } = useParams();
  const { data: order, isLoading } = useGetHook({
    queryKey: ["branch-invoice", `branch-invoice-${id}`],
    url: `${APIS.BRANCH_INVOICE}${id}/`,
    params: {},
  });
  return (
    <>
      <SwitchTab id={id} />
      {isLoading ? (
        <InvoiceSkeleton />
      ) : (
        <InvoicePreviewComponent order={order} id={id} />
      )}
    </>
  );
};

export default CargoBranchInvoicePreview;
